import { render, staticRenderFns } from "./ConfirmRegistration.vue?vue&type=template&id=4b376c8f&scoped=true"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRegistration.vue?vue&type=style&index=0&id=4b376c8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b376c8f",
  null
  
)

export default component.exports